import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsMxExtra from '@angular/common/locales/extra/es-MX';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Registrar el locale es-MX, el único que usa la aplicación (ver LOCALE_ID en app.config.ts)
registerLocaleData(localeEsMx, 'es-MX', localeEsMxExtra);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
